import type { BuilderGroup, CustomizationCatalog } from "../types";

type BuilderConfig = NonNullable<CustomizationCatalog["builder"]>;

const round2 = (value: number) => Math.round(value * 100) / 100;

/** Menor preço possível: base + a opção mais barata de cada categoria obrigatória. */
export const builderStartingPrice = (builder: BuilderConfig) =>
  round2(
    builder.product.price +
      builder.groups.reduce(
        (acc, g) => acc + (g.min > 0 ? g.min * Math.min(...g.ingredients.map((i) => i.price)) : 0),
        0,
      ),
  );

/** "Escolha 1", "Escolha de 1 a 3", "Opcional · até 2". */
export const builderRuleText = (g: BuilderGroup) =>
  g.min === g.max ? `Escolha ${g.min}` : g.min > 0 ? `Escolha de ${g.min} a ${g.max}` : `Opcional · até ${g.max}`;
